import React from 'react';
import classnames from 'classnames';
import Paper from '@material-ui/core/Paper';
import Translate, { useI18n } from '@hydra/common/components/i18n';
import Button from '@hydra/common/components/Button';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  floatingCta: {
    width: 170,
    height: 170,
    padding: theme.spacing(2.5),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  label: {
    fontWeight: theme.typography.fontWeightSemibold,
    fontSize: theme.typography.fontSizeRoot
  }
}));

interface FloatingCtaProps {
  className?: string | undefined
}

export default function FloatingCta ({ className: classNameProp }: FloatingCtaProps) {
  const classes = useStyles();
  const { locale } = useI18n();
  return (
    <Paper className={classnames(classes.floatingCta, classNameProp)}>
      <Typography className={classes.label} paragraph>
        <Translate content='free_review_floating_box_title' />
      </Typography>
      <Button
        href={`/${locale}/register/plan/v2pro`}
        variant='contained'
        color='success'
      >
        <Translate content='free_trial' with={{ count: '80' }} />
      </Button>
    </Paper>
  );
}
